/**
 * 典型原文卡片 — 左侧情绪色条 + 来源 + 日期 + 原文。
 */

interface QuoteCardProps {
  text: string;
  sentiment: number; // -1..1
  source?: string;
  date?: string;
  className?: string;
}

export default function QuoteCard({ text, sentiment, source, date, className = '' }: QuoteCardProps) {
  let stripeColor: string;
  if (sentiment > 0.3) stripeColor = '#16A34A';
  else if (sentiment < -0.3) stripeColor = '#DC2626';
  else stripeColor = '#94A3B8';

  return (
    <div
      className={`bg-white rounded-lg border border-slate-100 shadow-sm overflow-hidden flex ${className}`}
    >
      <div className="w-1 shrink-0" style={{ background: stripeColor }} />
      <div className="p-3 flex-1 min-w-0">
        <p className="text-[13px] text-slate-700 leading-relaxed m-0">{text}</p>
        {(source || date) && (
          <div className="mt-2 flex items-center gap-2 text-[11px] text-slate-400">
            {source && <span>{source}</span>}
            {source && date && <span>·</span>}
            {date && <span>{date}</span>}
          </div>
        )}
      </div>
    </div>
  );
}
